import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, OLD_SALES_REPORT_LIST, SALES_REPORT_LIST } from "../../../Constants/Config";
import { useAuthDetails } from "../../../Common/cookiesHelper";
const initialState = {
  loading: false,
  SalesReportData: [],
  successMessage: "",
  error: "",
};
// Generate pening , fulfilled and rejected action type
export const fetchOldSalesReportData = createAsyncThunk(
  "OldSalesReportList/fetchOldSalesReportData.",
  async (data) => {
    const { userTypeData } = useAuthDetails();
    try {
      const { token, ...otherUserData } = userTypeData;
      // console.log(BASE_URL + VENDORS_SALES_REPORT)
      const response = await axios.post(
        BASE_URL + OLD_SALES_REPORT_LIST,
        { ...data, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log(response)
      if (response.data.status === true) {
        // console.log(response.data.sales_data
        //     )
        return response.data.sales_data;
      }
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
const OldSalesReportSlice = createSlice({
  name: "SalesReportList",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchOldSalesReportData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOldSalesReportData.fulfilled, (state, action) => {
      state.loading = false;
      state.SalesReportData = action.payload;
      state.error = "";
    });
    builder.addCase(fetchOldSalesReportData.rejected, (state, action) => {
      state.loading = false;
      state.SalesReportData = {};
      state.error = action.error.message;
    });
  },
});
export default OldSalesReportSlice.reducer;